function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesIronFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.056 22H28v-7.974H13.063a.949.949 0 01-.093.005c-4.608 0-8.415 3.492-8.914 7.969zM19 8h6a1 1 0 011 1v3.026h2V6h-9v2zm-1-4h11a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1c0-6.016 4.867-10.916 10.871-10.97.032-.002.066-.004.099-.004H24V10h-6a1 1 0 01-1-1V5a1 1 0 011-1zm12 24H2v-2h28v2z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesIronFilled;